export default {
    title: "评分系统",
    footer: ["面试管理专家", "大型面试的好帮手", "版本{version}"],
    footerBoc: ["中国银行面试评分系统"],
    placeholder: {
        account: "账号",
        password: "密码",
    },
    login: "登录",
    detectionTips: "如有视频日程，请先进行",
    detectionButton: "设备检测",
    oidRequiredMsg: "登录链接缺少 oid，请使用正确的登录链接",
    failMsg: "用户名或密码错误，请重试",
};
